import type { GeolocationPolicy } from '../types';

export const COLLECT_CHECK_IN = 'in' as const;
export const COLLECT_CHECK_OUT = 'out' as const;
export const PUNCHCARD_TYPE = 'punchcard' as const;
export const COLLECTOR_UUID = '11111111-1111-1111-1111-111111111111' as const;
export const COLLECTOR_TYPE = 'worker' as const;
export const COLLECTOR_PLATFORM = 'web/development' as const;
export const CLOCK_INTERVAL_MS = 30_000;
export const GEO_TIMEOUT_MS = 15_000;
// Segunda tentativa, degradada: sem GPS fino e aceitando posição recente em cache.
// Uma leitura grosseira vem do cache e responde em dezenas de milissegundos, ou
// não responde: medido em 40ms no caminho feliz. Um orçamento maior que isso é
// quase todo espera desperdiçada, somada em série ao timeout da alta precisão —
// e o trabalhador paga essa soma parado na frente do relógio de ponto.
export const GEO_COARSE_TIMEOUT_MS = 4_000;
// Janela de cache aceita. Num registro de ponto, uma posição velha demais pode
// ser outro local; 60s equilibra o ganho do cache contra esse risco.
export const GEO_COARSE_MAX_AGE_MS = 60_000;
// PLATFORM-3394: rede de segurança contra o navegador que não chama nenhum callback.
// Piso = caminho nativo normal (alta precisão + degradada) + folga de timer, para
// nunca antecipar o `timeout` nativo; teto = 30s de tolerância do trabalhador.
export const GEO_WATCHDOG_MARGIN_MS = 3_000;
export const GEO_WATCHDOG_MS = GEO_TIMEOUT_MS + GEO_COARSE_TIMEOUT_MS + GEO_WATCHDOG_MARGIN_MS;
// Tempo oculto a partir do qual a posição confirmada é considerada velha ao voltar
// ao primeiro plano: a mesma janela de cache já aceita pela leitura degradada.
export const GEO_STALE_AFTER_HIDDEN_MS = GEO_COARSE_MAX_AGE_MS;
export const GEO_MAX_ACCURACY_METERS = 1000;
export const GEOLOCATION_POLICY = {
  REQUIRED: 'required',
  FLEXIBLE: 'flexible',
  DISPENSED: 'dispensed',
} as const satisfies Record<string, GeolocationPolicy>;
/** Prova de permissão (nível 1) que sobrevive à remontagem do componente. */
export const GEO_PERMISSION_PROOF_KEY = 'punchcard_geo_permission_proof';
// PLATFORM-3335: evita reiniciar o ciclo de leitura (~19s) do zero a cada disparo,
// caso o navegador reporte `onchange: prompt` repetidamente em sequência (não
// confirmado em teste real — proteção defensiva, ver plano do PLATFORM-3335).
export const PROMPT_REVERIFY_DEBOUNCE_MS = 5_000;
// PLATFORM-3336: timeout só da mutação de envio (não do apiClient inteiro — isso
// afetaria export/PDF). Servidor só rejeita reenvio com o datetime EXATO igual
// (constraint de unicidade, confirmado em teste contra o backend real); um retry
// com datetime novo passa direto e duplica. Por isso todo timeout de envio precisa
// reconciliar contra coletas recentes antes de decidir se foi de fato registrado.
export const PUNCHCARD_SUBMIT_TIMEOUT_MS = 20_000;
// Janela generosa o bastante para cobrir a latência real de uma resposta lenta
// (o timeout acima já é 20s) sem casar com um punch anterior não relacionado.
export const PUNCHCARD_RECONCILE_WINDOW_MS = 5 * 60_000;
export const LABS_SETTINGS_KEY = 'labs_settings';
export const USER_PREFS_KEY = 'user_prefs';
